<template>
  <div class="container">
    <sheet :id="$route.params.id"></sheet>
  </div>
</template>

<script>
import Sheet from "@/components/character/_Sheet";

export default {
  name: "character-sheet",
  components: {
    Sheet
  }
};
</script>

<style lang="scss" scoped>
@media (min-width: 1200px) {
  .container {
    width: 1140px !important;
    max-width: 100% !important;
  }
}
</style>
